const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e3eca2f5-a37a-4787-8c6f-2de0c6377144",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.28,11.07H3.17a.39.39,0,0,0-.39.39.4.4,0,0,0,.39.39H6.28a.4.4,0,0,0,.37-.41.39.39,0,0,0-.37-.37ZM7.83,9.52H3.17a.39.39,0,0,0,0,.77H7.83a.38.38,0,0,0,.37-.4.39.39,0,0,0-.37-.37ZM7.83,8H3.17a.4.4,0,0,0-.37.41.39.39,0,0,0,.37.37H7.83a.38.38,0,0,0,.37-.41A.39.39,0,0,0,7.83,8Zm0-1.55H3.17a.39.39,0,0,0-.37.41.38.38,0,0,0,.37.36H7.83a.38.38,0,0,0,.37-.4.39.39,0,0,0-.37-.37Zm1.56,7H1.62A.38.38,0,0,1,1.23,13V2.08a.39.39,0,0,1,.39-.39h5v2A1.17,1.17,0,0,0,7.83,4.8H9.77V13A.38.38,0,0,1,9.39,13.4ZM7.44,2.24,9.22,4H7.83a.4.4,0,0,1-.39-.39Zm3,1.9L7.33,1A.39.39,0,0,0,7.05.92H1.61A1.16,1.16,0,0,0,.45,2.08V13a1.17,1.17,0,0,0,1.17,1.17H9.39A1.16,1.16,0,0,0,10.55,13V4.41a.39.39,0,0,0-.11-.27Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.35ad92c07487e34146efac364e69aa66.svg";
export { ForwardRef as ReactComponent };